// extracted by mini-css-extract-plugin
module.exports = {"cardContent":"account_cardContent__2J6fQ","refer":"account_refer__3LUkk","table":"account_table__2jswo","status":"account_status__1jI0U"};